import type { RefObject } from 'react'

export const handleSubmitError = ({ formRef, isDesktop }: { formRef: RefObject<HTMLDivElement | null>; isDesktop: boolean }) => {
  if (formRef.current) {
    const headerOffset = isDesktop ? 100 : 80

    const elementTop = formRef.current.getBoundingClientRect().top + window.scrollY
    const targetScroll = elementTop - headerOffset

    setTimeout(() => {
      window.scrollTo({
        top: targetScroll,
        behavior: 'smooth',
      })
    }, 50)
  }
}
